module.exports = __webpack_public_path__ + "img/校园图片.cd2e0ef6.png";